'use strict';

module.exports = {
    TRACK_ACTION: 'page-flow-track-action',

    TRACK_ID: 'page-flow-track-id',

    TRACKED: 'page-flow-tracked',

    validFlows: {
        payment_flow_appearances: 'payment_flow_appearances',
        payment_flow_action: 'payment_flow_action',
    },

    validPlaceholders: {
        policy: 'policy-placeholder',
    },
};
